<template>
    <div :id="this.idSimpleForm"
	:data-id="this.id"
         class="sitebuilder-element-container"
         element="SimpleFormComponent"
		:class="internal_config.recaptchaSiteKey ? 'recaptcha' : ''"
         :data-tag="dataTag()"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         :style="style()">
      <div :style="`transform: rotate(${this.$props.device === 'desktop' ? this.internal_config.rotation : 0}) scale(1)`">
        <form  v-if="checkGdpr()" @submit.prevent="submit($event, internal_config)"
              :class="horizontal ? 'form-mboss horizontal-form': 'form-mboss'" ref="form"
              method="post" :action="internal_config.action"
              :receiver="internal_config.receiver" :subject="internal_config.subject">
          <input type="hidden" name="origin_uid" v-model="originUid">
            <div class="inputs-area" ref="container"></div>
			<altcha-widget debug="true" v-if="internal_config.recaptchaSiteKey == ''" id="altchaWidget" class="altchaWidget" :challengejson="alcaptchaChallengeJson"
                hidefooter auto @statechange="onAltchaStateChange"
                style="--altcha-border-radius: 5px; --altcha-max-width: 350px; --altcha-color-base: #f0f0f088;" />
            <div class="recaptcha-container" v-if="internal_config.recaptchaSiteKey">
              <vue-recaptcha :sitekey="internal_config.recaptchaSiteKey"></vue-recaptcha>
            </div>
            <div class="place-btn" :style="{ margin: buttonMargin}">
                <div class="bt-sb"
                     v-bind:style="{
                        width : buttonWidth,
                        border : buttonBorder,
                        'border-radius': buttonRadius,
                        background: buttonBackground,
                        'box-shadow': buttonBoxShadow
                        }">
                  <div class="bt-text-area d-flex align-items-center flex-wrap overflow-hidden"
                       :style="{minHeight: buttonHeight}">
                    <a v-on:click="submit($event, internal_config)"
                       class="sb-text"
                       ref="buttonClick"
                       :class="{'disabled' : iconLoading}"
                       :style="textStyle()">
                      <span class="spinner-border spinner-border-sm mr-1" role="status"
                            aria-hidden="true" v-if="iconLoading"></span>{{ internal_config.button.text }}
                    </a>
                    <small class="sb-sub-text"
                           @click="$refs.buttonClick.click()"
                           v-show="this.internal_config.button.subText != ''"
                           :style="subTextStyle()">{{ internal_config.button.subText }}</small>
                  </div>
                </div>
            </div>
        </form>
      </div>
    </div>
</template>

<script>

	import Vue from 'vue';
	import axios from 'axios';
	import Data from './Model';
	import VueRecaptcha from 'vue-recaptcha';

	import CheckFields from "../Fields/CheckFields.vue";
	import SelectFields from "../Fields/SelectFields.vue";
	import TextFields from "../Fields/Text.vue";
	import DateFields from "../Fields/DateFields.vue";
  	import MixinForm from "@/components/apps/Forms/MixinForm";
	import { loadAltcha } from '../../../../../src/js/mixins/captcha';

	export default {
		name: 'SimpleFormComponent',
		props: ['config', 'id', 'preview', 'device'],
    mixins: [MixinForm],
		components: {
			VueRecaptcha,
			
		},
		computed: {
			horizontal() {
				return this.internal_config.horizontal;
			},
			buttonWidth() {
				return parseInt(this.internal_config.button.width) + '% !important';
			},
			buttonHeight() {
				return parseInt(this.internal_config.button.height) + 'px';
			},
			buttonBorder() {
				return this.internal_config.button.border;
			},
			buttonBoxShadow() {
				return this.internal_config.button.boxShadow;
			},
			buttonRadius() {
				return this.internal_config.button.borderRadius;
			},
			buttonBackground() {
				let bg = this.internal_config.button.backgroundColor;

				if(this.$globalStoreHelpers.isValidHex(bg)){
					bg = this.$globalStoreHelpers.hexToRGBA(bg);
				}

				if (this.internal_config.backgroundImage && this.internal_config.backgroundImage !== 'none') {
					bg += ' url("' + this.internal_config.button.backgroundImage + '")';
					bg += ' ' + this.internal_config.button.backgroundPosition;
					bg += ' / ' + this.internal_config.button.backgroundSize;
					bg += ' ' + this.internal_config.button.backgroundRepeat;
					bg += ' ' + this.internal_config.button.backgroundOrigin;
				}

				return bg;
			}

		},
		data() {
    		return Data.data();
		},
		methods: {

            registerOnSocialProof() {

                try {

                    let campaignId = parseInt(this.internal_config.socialproof_campaign_id);
                    let userNameTAG = this.internal_config.socialproof_user_name_tag;

                    let inputUserName = this.$refs.form.querySelector(`[name="${userNameTAG}"]`);

                    if (campaignId && userNameTAG && inputUserName) {
                        var formData = new FormData();
                        formData.set('user_name', inputUserName.value);

                        axios({
                            'method': 'post',
                            'url': '/cheetah/social-proof/register/' + campaignId,
                            data: formData,
                        }).then((res) => {
                        });
                    }
                } catch (e) {
                    console.error(e);
                }
            },

			generateId(){
				return 1 + Math.floor((200000 - 1) * Math.random());
			},
			dataTag() {
				if (this.internal_config.tag) {
					return this.internal_config.tag;
				}
				return '';
			},

			getValidUrl(url = "") {
				let newUrl = url.trim().replace(/\s/g, "");
				newUrl = window.decodeURIComponent(newUrl);

				if (/^(:\/\/)/.test(newUrl)) {
					return `http${newUrl}`;
				}
				if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
					return `http://${newUrl}`;
				}

				return newUrl;
			},

			submit(e, config) {

				e.preventDefault()

				var kvpairs = [];
				let form = document.getElementById(this.idSimpleForm).querySelector('form');
                var inputs = form.querySelectorAll('.form-group, .input-group');
				let valid = true;
				let message = [];

				const inputsValidation = form.querySelectorAll('input');

				for (let i = 0; i < inputsValidation.length; i++) {
					const x = inputsValidation[i];
					
					if (x.getAttribute('validation') === 'fullname') {
						const regex = /^[a-zA-Z]{2,}\s+[a-zA-Z]{2,}(?:\s+[a-zA-Z]{2,})*$/;

						if (!regex.test(x.value)) {
							valid = false;
							message.push(this.$t('ct-please-enter-valid-fullname')+'.')
						}
					}
				}


                for (var i = 0; i < inputs.length; i++) {
                    var el = inputs[i].querySelector('input, select, textarea');
                    var checkFieldsRequired = inputs[i].hasAttribute('data-check-required');

                    if(!checkFieldsRequired) {
                        config.fields.forEach(field => {

							try {

								if(el.name.toLowerCase().indexOf('email') !== -1 && el.value !== ''){
									localStorage.setItem('leadEmail',el.value);
								}

								if(el.name.toLowerCase() === 'fname' && el.value !== ''){
									localStorage.setItem('leadName',el.value);
								}

								if(el.name.toLowerCase() === 'name' && el.value !== ''){
									localStorage.setItem('leadName',el.value);
								}

								if(el.name.toLowerCase() === 'fnome' && el.value !== ''){
									localStorage.setItem('leadName',el.value);
								}

								if(el.name.toLowerCase() === 'nome' && el.value !== ''){
									localStorage.setItem('leadName',el.value);
								}

								if(el.name.toLowerCase() === 'cadastro_nome' && el.value !== ''){
									localStorage.setItem('leadName',el.value);
								}

							} catch (error) {
								console.log(error)
							}

                        	if(el.name.toLowerCase().indexOf('email') !== -1 && el.value !== ''){
								localStorage.setItem('leadEmail',el.value);
                            }
                            if (field.tag === el.name && field.required === 'yes' && el.value === '') {
								valid = false;
								var isRequiredMessage = config.isRequiredMessage != '' ? config.isRequiredMessage : "is required";
                                message.push(field.label + " " + isRequiredMessage + ".")
                            }
                        });

                        kvpairs.push(encodeURIComponent(el.name) + "=" + encodeURIComponent(el.value));
                    } else {

                        let inputsCheck = inputs[i].querySelectorAll('[type=checkbox][data-check-field],[type=radio][data-check-field]');
                        let checked = 0;
                        let values = [];

                        if (inputsCheck.length > 0) {

                            inputsCheck.forEach(element => {
                                if (element.checked) {
                                    checked++;
                                    values.push(element.value);
                                }

                            });

                            let inputsCheckRequired = inputs[i].querySelectorAll('[type=checkbox][data-required=true],[type=radio][data-required=true]');

                            if (inputsCheckRequired.length > 0 && checked === 0) {

                                config.fields.forEach(field => {
                                    let name = field.field === 'checkbox' ? field.tag + '[]' : field.tag;

                                    if (name === el.name && field.required === 'yes' && checked === 0 && (field.field === 'radio' || field.field === 'checkbox')) {
                                        valid = false;
                                        var isRequiredMessage = config.isRequiredMessage !== '' ? config.isRequiredMessage : "is required";
                                        message.push(field.label + " " + isRequiredMessage + ".")
                                    }
                                });

                            }

                            if(values.length > 0) {
                                values.forEach(value => {
                                    kvpairs.push(encodeURIComponent(el.name) + "=" + encodeURIComponent(value));
                                });
                            }else{
                                kvpairs.push(encodeURIComponent(el.name) + "=");
                            }
                        }
                    }

				}

				var queryString = kvpairs.join("&");


				if (valid) {

					let action = this.internal_config.action;

					if (action && action.trim() !== '') {

						if (typeof __baCRMTracking !== 'undefined') {
							__baCRMTracking.onSubmit(e)
						}

						if(localStorage.getItem('MAILING_BOSS_TRACKING') && localStorage.getItem('leadEmail') != null && typeof MailingBossTracking != 'undefined'){
							console.log('mboss lead register');
                            var options = {
                                leadEmail: localStorage.getItem('leadEmail'),
                                reference: localStorage.getItem('MAILING_BOSS_REFERENCE')
                            };
                            MailingBossTracking.init(localStorage.getItem('MAILING_BOSS_TOKEN'), options);
                        }

						let vm = this;

						if (action.indexOf('app.mailingboss.com') > 0) {
							if (typeof config.redirect !== 'undefined' && config.redirect.trim() !== '') {
									if (action.indexOf("?") !== -1) {
										this.internal_config.action = action + '&redir=' + vm.getValidUrl(config.redirect);
									} else {
										this.internal_config.action = action + '?redir=' + vm.getValidUrl(config.redirect);
									}
									}
									setTimeout(function () {
										vm.registerOnSocialProof();

										// send resolved captcha to mb (use "alcaptcha" name, instead of "altcha")
										let altchaInput = vm.$refs.form.querySelector(`input[name=altcha]`);
										if (altchaInput) {
											altchaInput.name = 'alcaptcha'
										}

										vm.$refs.form.submit();
									}, 2000);
							} else {
								let recaptchaResponse = (document.getElementById('g-recaptcha-response') || {}).value;
								if (this.internal_config.recaptchaSiteKey) {
									if (recaptchaResponse === '' || recaptchaResponse === null) {
										valid = false;
										message.push("Unverified reCAPTCHA");
									}
								} else if (!this.alcaptchaResponse) {
									valid = false;
									message.push("Unverified ALTCHA");
								}

							if (!valid) {
								this.$root.$emit('errorMessagePopup', message);
								return;
							}

							vm.registerOnSocialProof();
							if (vm.internal_config.action.indexOf('https://office.builderall.com/br/office/create') > -1) {
								vm.iconLoading = true;
								let body = document.getElementsByTagName('body')[0]
								body.classList.add('loading-office-checkout');
							}


							if (
								typeof config.redirect !== 'undefined' &&
								config.redirect.trim() !== ''
								) {
								axios.post(vm.internal_config.action, queryString)
								.then( res => {
									window.location.href = vm.getValidUrl(config.redirect);
								} )

								setTimeout(function () {
									window.location.href = vm.getValidUrl(config.redirect);
								}, 2000);
							} else {
								this.$refs.form.submit();
							}


							}

					} else {

						if (config.receiver === '' || config.receiver === null) {
							valid = false;
							message.push("receiver not configured");
						}

						if (config.subject === '' || config.subject === null) {
							valid = false;
							message.push("subject not configured");
						}

						let recaptchaResponse = (document.getElementById('g-recaptcha-response') || {}).value;
						if (this.internal_config.recaptchaSiteKey){ 
							if (recaptchaResponse === '' || recaptchaResponse === null) {
								valid = false;
								message.push("unverified reCAPTCHA");
							}
						} else if (!this.alcaptchaResponse) {
							valid = false;
							message.push("unverified ALTCHA");
						}

						if (valid) {

							if (typeof __baCRMTracking !== 'undefined') {
								__baCRMTracking.onSubmit(e)

							}

							if(this.internal_config.recaptchaSiteKey) {
								queryString = queryString + '&g-recaptcha-response=' + recaptchaResponse + '&id=' + this.id;
							} else {
								queryString = queryString + '&alcaptcha=' + this.alcaptchaResponse
							}

							let vm = this;

							queryString = queryString + '&receiver=' + config.receiver + '&subject=' + config.subject;
								axios.post('/cheetah/form_submit', queryString)
								.then(res => {
                                    vm.registerOnSocialProof();

									vm.$root.$emit('successMessagePopup', config.successMessage);
									if (config.redirect.trim() !== '') {
										window.location.href = this.getValidUrl(config.redirect);
									}
								}).catch(err => {
									alert(err);
								})
						}
					}


				}
				if (!valid) {
					// this.errorMessage = message;
					// this.$refs.required_fields.open()
					e.preventDefault();
					this.$root.$emit('errorMessagePopup', message);
				}

				// this.$refs.form.submit()
			},
			save() {
				this.buildFields(this)
				this.$refs.modal.close();
			},
			buildFields: function (vm) {

				this.$refs.container.innerHTML = '';

				vm.internal_config.fields.forEach(field => {
					let identifier = field.field;
					if (typeof identifier === 'undefined') {
						identifier = 'text';
					}


					if (identifier === 'textarea') vm.createTextField(field, true);
					if (identifier === 'text') vm.createTextField(field, false);
					if (identifier === 'password') vm.createTextField(field, false, true);
					if (identifier === 'multiselect') vm.createDropDown(field, true);
					if (identifier === 'select') vm.createDropDown(field, false);
					if (identifier === 'dropdown') vm.createDropDown(field, false);
					if (identifier === 'datetime') vm.createDateTime(field, true);
					if (identifier === 'date') vm.createDateTime(field, false);
					if (identifier === 'checkbox') vm.createCheckField(field, 'checkbox');
					if (identifier === 'radio') vm.createCheckField(field, 'radio');
				});
				$('body').removeClass('loading');
			},

			textStyle() {
        let sizeMobile = typeof this.internal_config.button.textStyle.sizeMobile !== 'undefined' && this.internal_config.button.textStyle.sizeMobile ?
            this.internal_config.button.textStyle.sizeMobile : false;
				return `font-family:  ${this.internal_config.button.textStyle.family};
                 font-size: ${(this.device === 'mobile' && sizeMobile) ? sizeMobile : this.internal_config.button.textStyle.size};
                 text-align: ${this.internal_config.button.textStyle.align};
                 font-weight: ${this.internal_config.button.textStyle.weight};
                 font-style: ${this.internal_config.button.textStyle.style};
                 color: ${this.internal_config.button.textStyle.color}`;
			},

			subTextStyle() {
        let sizeMobile = typeof this.internal_config.button.subTextStyle.sizeMobile !== 'undefined' && this.internal_config.button.subTextStyle.sizeMobile ?
            this.internal_config.button.subTextStyle.sizeMobile : false;
				return `font-family:  ${this.internal_config.button.subTextStyle.family};
                 font-size: ${(this.device === 'mobile' && sizeMobile) ? sizeMobile : this.internal_config.button.subTextStyle.size};
                 text-align: ${this.internal_config.button.subTextStyle.align};
                 font-weight: ${this.internal_config.button.subTextStyle.weight};
                 font-style: ${this.internal_config.button.subTextStyle.style};
                 color: ${this.internal_config.button.subTextStyle.color}`;
			}
			,
			buildIcon: function () {

				$(this.$el).find('i').detach();

				if (this.internal_config.button.icon !== '') {
					if (this.internal_config.button.iconPosition === 'left') {
						$('<i>').addClass(this.$addIconPrefix(this.internal_config.button.icon)).prependTo($(this.$el).find('.sb-text').get(0));
					}
					if (this.internal_config.button.iconPosition === 'right') {
						$('<i>').addClass(this.$addIconPrefix(this.internal_config.button.icon)).appendTo($(this.$el).find('.sb-text').get(0));
					}
				}
			}
			,
			build(config) {
				this.internal_config = config;

				this.buildIcon();
			}
			,
			style() {
				return `left:  ${this.internal_config.left};
				        padding-top: ${this.internal_config.paddingTop};
                     z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                width: ${this.internal_config.width};
								top: ${this.internal_config.top};`;
			}
			,

			createCheckField(field, type) {
				let ComponentClass = Vue.extend(CheckFields);
				let instance = new ComponentClass({
					propsData: {
						type: type,
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						label: field.label,
						options: field.options,
                        required: field.required,
						selected: [],
						data: field,
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			},
			createDropDown(field, multiple) {
				let ComponentClass = Vue.extend(SelectFields);
				let instance = new ComponentClass({
					propsData: {
						label: field.label,
						options: field.options,
						selected: field.default_value,
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						data: field,
						multiple: multiple,
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			},
			createDateTime(field, useCurrent) {

				let ComponentClass = Vue.extend(DateFields);
				let instance = new ComponentClass({
					propsData: {
						label: field.label,
						data: field,
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						value: new Date().toString(),
						type: (useCurrent ? 'datetime' : 'date'),
                        icon: field.icon
					}
				});
				instance.$mount();
				this.$refs.container.appendChild(instance.$el)
			},
			createTextField(field, area, pass) {


				let ComponentClass = Vue.extend(TextFields);
				let instance = new ComponentClass({
					propsData: {
						label: field.label,
						pass: pass,
						value: field.default_value,
						showLabel: this.internal_config.showLabel,
						showPlaceholder: this.internal_config.showPlaceholder,
						data: field,
						area: area,
                        icon: field.icon,
						validation: field.validation
					}
				});
				instance.$mount();


				this.$refs.container.appendChild(instance.$el)
			},
    	placeholderStyle() {
				const elements = this.$refs.container.getElementsByClassName(
					'form-control'
				);

				for (let element of elements) {
					element.style.setProperty('--placeholder-color', this.internal_config.placeholderColor || '#5c5c5c');
				}
    	},
			inputStyle() {

				let vm = this;

				let elements = this.$refs.container.getElementsByClassName('form-control');
				[].forEach.call(elements, function (el) {
					el.style.backgroundColor = vm.internal_config.inputBgColor;
					el.style.border = vm.internal_config.inputBorder;

                    if(el.tagName === 'TEXTAREA' && vm.internal_config.textareaHeight) {
                        el.style.height = vm.internal_config.textareaHeight;
                        el.classList.add('form-control-textarea-has-height');
                    } else {
                        el.style.height = vm.internal_config.inputHeight;
                    }
					el.style.borderRadius = vm.internal_config.inputRadius;

					el.style.fontFamily = vm.internal_config.inputStyle.family;
					el.style.fontSize = vm.internal_config.inputStyle.size;
					el.style.textAlign = vm.internal_config.inputStyle.align;
					el.style.fontStyle = vm.internal_config.inputStyle.style;
					el.style.fontStyle = vm.internal_config.inputStyle.style;
					el.style.color = vm.internal_config.inputStyle.color;
				});

				vm.$el.style.color = vm.internal_config.labelStyle;
			},

	  getCookie(cname) {
			var name = cname + "=";
			var decodedCookie = decodeURIComponent(document.cookie);
			var ca = decodedCookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return false;
		},

		checkGdpr() {

			try{
				if(window.gdprSettings && window.gdprSettings.active) {
					if(this.internal_config.recaptchaSiteKey) {
						return this.getCookie('cookieControl')
					}
				}
			}catch(e) {
				console.log(e)
			}


			return true;
		},
		
		async loadingAltcha() {
			try {
				const { data } = await loadAltcha();
				this.alcaptchaChallengeJson = JSON.stringify(data);
			} catch (error) {
				console.error('Falha ao carregar ALTCHA Captcha:', error);
			}
		},

		onAltchaStateChange(event) {
			const { payload, state } = event.detail || {};
			console.log('response' + this.alcaptchaResponse)
			if (state === "verified" && payload) {
				this.alcaptchaResponse = payload
			} else {
				// Falhou, expirou ou ainda não resolvido
			}
		}
	},
    mounted() {

      let vm = this;

      this.build(this.$props.config);

      this.internal_config.button.subText = this.internal_config.button.subtext;

      Object.keys(this.props).forEach(prop => {
        if (typeof this.internal_config[prop] === 'undefined') {
          this.internal_config[prop] = this.props[prop];
        }
      });


      // if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

      this.$el.classList.add('preview');

      this.$el.addEventListener('mouseover', function () {

        if (vm.$globalStoreHelpers.isValidHex(vm.internal_config.button.backgroundColorHover)) {
          vm.internal_config.button.backgroundColorHover = vm.$globalStoreHelpers.hexToRGBA(vm.internal_config.button.backgroundColorHover);
        }
        if (vm.$globalStoreHelpers.isValidHex(vm.internal_config.button.textColorHover)) {
          vm.internal_config.button.textColorHover = vm.$globalStoreHelpers.hexToRGBA(vm.internal_config.button.textColorHover);
        }

        document.body.style.setProperty('--button-background-color--hover', vm.internal_config.button.backgroundColorHover);
        document.body.style.setProperty('--button-text-color--hover', vm.internal_config.button.textColorHover);
      });
      // }

      /**
       * configuração para listas do tipo ranking
       */
      let originUrl = new URL(window.location.href)
      let param = originUrl.searchParams.get('origin_uid');
      if (param !== null) {
        this.originUid = param
      }


      this.buildFields(this);

      this.inputStyle();
      this.placeholderStyle()

      this.setColumns();

      if (!this.internal_config.recaptchaSiteKey){
        this.loadingAltcha();
      }

      if (typeof this.internal_config.horizontal_config !== 'undefined') {
        var configMobile = (typeof this.internal_config.horizontal_config_mobile !== 'undefined') ? this.internal_config.horizontal_config_mobile : false;
        this.testAlan(this.internal_config.horizontal_config, configMobile)
      }

    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .sitebuilder-element-container .vdr,
    .vdr, .bt-sb,
    form.form-simple {
        height: auto !important;
    }

    .place-btn {
        text-align: center;

        .bt-sb {
            display: inline-block;
        }
    }

    .bt-text-area {
      display: block;

      .sb-text.disabled {
        pointer-events: none;
      }
    }

    [data-device="mobile"] .bt-text-area {
        width: auto !important;
    }

    .bt-sb:hover {
        cursor: pointer;
        background: var(--button-background-color--hover) !important;
        color: var(--button-text-color--hover) !important;
        -webkit-text-fill-color: var(--button-text-color--hover) !important;
    }

</style>
<style lang="scss">

label{
  max-width: 100%;
  word-wrap: break-word
}

    select.form-control[multiple], select.form-control[size],
    textarea.form-control:not(.form-control-textarea-has-height) {
        height: auto !important;
    }

  input.form-control, textarea.form-control {
    	&::placeholder {
      	color: var(--placeholder-color);
    	}
  	}



    .list-item {
        display: block;
        width: 100%;
        border: 1px solid lightgrey;
        border-radius: 5px;
        margin-top: 2px;
        cursor: pointer;
    }

    .list-item.selected {
        border: 1px solid blue;
    }

    .recaptcha-container {
      display: flex;
      justify-content: center;
      margin-bottom: 1rem;
}
.altchaWidget {
	display: flex;
	justify-content: center;
		.altcha{
    		margin-bottom: 1rem !important;
			.altcha-main{
				gap: 1rem !important;
				padding: .6rem 1rem !important;
			}
			.altcha-error{
				align-items: center;
			}
		}
	
		body {
			background-color: #fff;
		}
	
		.subtitle {
			font-weight: 400;
			font-size: 18px;
			margin-top: 8px;
			margin-bottom: 28px;
		}
	
		.description {
			font-weight: 400;
			font-size: 18px;
			margin-top: 68px;
		}
	
		footer {
			border-top: 1px solid #b0b0b0;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			gap: 2vh;
			margin: 0px 15%;
		}
	
		footer span {
			margin-top: 5px;
			color: #b0b0b0;
		}
	
		.container {
			margin: 12vh 15%;
			height: calc(100vh - 28vh);
		}
	
		.sub-container {
			display: flex;
			flex-direction: column;
		}
	
		.altcha-label {
			font-size: 18px;
			margin-bottom: 0px !important;
		}
	
		.altcha-checkbox {
			width: 24px !important;
		}
	
		.altcha-checkbox input {
			width: 24px !important;
			height: 24px !important;
		}
	
		.altcha-logo svg {
			display: none;
		}
	
		.altcha-logo::before {
			display: flex;
			align-items: center;
			justify-content: center;
			content: '';
			width: 50px;
			height: 50px;
			top: 10px !important;
			position: relative;
			background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="40px" height="25px" viewBox="0 0 40 25" version="1.1"><g id="surface1"><path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,44.705883%,88.235295%);fill-opacity:1;" d="M 24.578125 24.242188 C 24.738281 24.347656 24.910156 24.425781 25.089844 24.480469 C 25.484375 24.605469 25.90625 24.628906 26.3125 24.542969 C 26.863281 24.410156 27.367188 24.117188 27.753906 23.699219 C 27.960938 23.496094 28.171875 23.296875 28.386719 23.097656 C 28.929688 22.597656 29.484375 22.109375 30.046875 21.628906 C 30.570312 21.175781 31.097656 20.726562 31.632812 20.285156 C 31.898438 20.058594 32.175781 19.839844 32.441406 19.609375 L 32.453125 19.601562 C 32.691406 19.359375 32.691406 18.96875 32.453125 18.726562 C 32.339844 18.613281 32.183594 18.546875 32.019531 18.546875 L 31.859375 18.570312 C 31.757812 18.597656 31.664062 18.652344 31.589844 18.726562 C 31.148438 19.089844 30.707031 19.457031 30.273438 19.828125 C 29.449219 20.527344 28.621094 21.226562 27.824219 21.953125 C 27.625 22.132812 27.429688 22.3125 27.234375 22.496094 C 27.023438 22.695312 26.824219 22.914062 26.59375 23.09375 L 26.722656 22.996094 C 26.5625 23.121094 26.386719 23.226562 26.203125 23.308594 L 26.347656 23.242188 C 26.203125 23.304688 26.046875 23.347656 25.890625 23.371094 L 26.050781 23.351562 C 25.894531 23.371094 25.738281 23.371094 25.585938 23.351562 L 25.746094 23.371094 C 25.59375 23.351562 25.441406 23.308594 25.296875 23.246094 L 25.441406 23.3125 C 25.359375 23.277344 25.277344 23.234375 25.199219 23.183594 C 24.984375 23.054688 24.714844 23.074219 24.519531 23.226562 C 24.320312 23.378906 24.234375 23.636719 24.300781 23.878906 C 24.351562 24.03125 24.449219 24.160156 24.582031 24.25 Z M 20.375 24.242188 C 20.53125 24.347656 20.703125 24.425781 20.886719 24.480469 C 21.28125 24.605469 21.699219 24.628906 22.105469 24.542969 C 22.660156 24.410156 23.160156 24.117188 23.550781 23.699219 C 23.753906 23.496094 23.964844 23.296875 24.179688 23.097656 C 24.722656 22.597656 25.28125 22.109375 25.839844 21.628906 C 26.367188 21.175781 26.894531 20.726562 27.425781 20.285156 C 27.695312 20.058594 27.972656 19.839844 28.234375 19.609375 L 28.246094 19.601562 C 28.484375 19.359375 28.484375 18.96875 28.246094 18.726562 C 28.132812 18.613281 27.976562 18.546875 27.816406 18.546875 L 27.652344 18.570312 C 27.550781 18.597656 27.457031 18.652344 27.382812 18.726562 C 26.941406 19.089844 26.503906 19.457031 26.066406 19.828125 C 25.242188 20.527344 24.417969 21.226562 23.617188 21.953125 C 23.417969 22.132812 23.222656 22.3125 23.027344 22.496094 C 22.816406 22.695312 22.617188 22.914062 22.390625 23.09375 L 22.515625 22.996094 C 22.355469 23.121094 22.183594 23.226562 21.996094 23.308594 L 22.144531 23.242188 C 21.996094 23.304688 21.839844 23.347656 21.683594 23.371094 L 21.847656 23.351562 C 21.691406 23.371094 21.535156 23.371094 21.378906 23.351562 L 21.542969 23.371094 C 21.386719 23.351562 21.238281 23.308594 21.09375 23.246094 L 21.238281 23.3125 C 21.152344 23.277344 21.074219 23.234375 20.996094 23.183594 C 20.78125 23.054688 20.511719 23.074219 20.3125 23.226562 C 20.117188 23.378906 20.03125 23.636719 20.097656 23.878906 C 20.144531 24.03125 20.246094 24.160156 20.378906 24.25 Z M 35.644531 12.890625 C 36.113281 12.890625 36.492188 12.507812 36.492188 12.035156 C 36.492188 11.5625 36.113281 11.179688 35.644531 11.179688 C 35.175781 11.179688 34.796875 11.5625 34.796875 12.035156 C 34.796875 12.507812 35.175781 12.890625 35.644531 12.890625 Z M 24.09375 14.675781 L 23.804688 14.507812 L 21.835938 13.382812 L 20.390625 12.554688 L 18.796875 11.632812 C 17.730469 11.019531 16.671875 10.40625 15.609375 9.785156 C 15.160156 9.523438 14.707031 9.257812 14.257812 8.992188 C 13.90625 8.78125 13.558594 8.574219 13.210938 8.363281 C 13.007812 8.234375 12.800781 8.113281 12.601562 7.976562 L 12.53125 7.921875 L 12.65625 8.019531 L 12.652344 8.015625 C 12.535156 7.902344 12.378906 7.839844 12.21875 7.832031 C 12.015625 7.835938 11.824219 7.9375 11.710938 8.109375 C 11.597656 8.28125 11.574219 8.496094 11.652344 8.6875 C 11.683594 8.761719 11.726562 8.828125 11.785156 8.886719 C 11.976562 9.035156 12.175781 9.167969 12.378906 9.292969 C 13.117188 9.742188 13.855469 10.1875 14.601562 10.621094 C 16.1875 11.550781 17.777344 12.472656 19.371094 13.386719 L 20.875 14.25 L 22.132812 14.972656 L 23.035156 15.484375 C 23.175781 15.566406 23.316406 15.648438 23.460938 15.730469 L 23.476562 15.738281 C 23.621094 15.820312 23.789062 15.84375 23.949219 15.804688 C 24.1875 15.738281 24.363281 15.535156 24.394531 15.289062 C 24.425781 15.042969 24.308594 14.800781 24.09375 14.675781 Z M 20.921875 17.28125 L 20.617188 17.105469 L 19.792969 16.628906 L 18.566406 15.914062 L 17.058594 15.035156 L 15.394531 14.0625 L 13.691406 13.0625 C 12.683594 12.46875 11.675781 11.871094 10.671875 11.273438 C 10.3125 11.054688 9.953125 10.835938 9.59375 10.613281 C 9.378906 10.484375 9.164062 10.351562 8.960938 10.210938 C 8.9375 10.195312 8.910156 10.175781 8.890625 10.15625 L 9.015625 10.253906 L 9.007812 10.25 C 8.890625 10.140625 8.738281 10.074219 8.574219 10.070312 C 8.371094 10.070312 8.179688 10.171875 8.066406 10.34375 C 7.953125 10.515625 7.933594 10.730469 8.007812 10.921875 C 8.039062 10.996094 8.085938 11.066406 8.144531 11.121094 C 8.335938 11.273438 8.539062 11.410156 8.75 11.539062 C 9.070312 11.738281 9.398438 11.9375 9.722656 12.132812 C 10.167969 12.402344 10.613281 12.671875 11.058594 12.933594 C 12.148438 13.582031 13.238281 14.222656 14.328125 14.863281 L 16.03125 15.855469 L 17.589844 16.765625 L 18.902344 17.535156 L 19.84375 18.082031 C 19.992188 18.167969 20.140625 18.253906 20.289062 18.335938 L 20.308594 18.347656 C 20.449219 18.429688 20.621094 18.453125 20.777344 18.410156 C 21.015625 18.34375 21.191406 18.140625 21.222656 17.894531 C 21.253906 17.652344 21.136719 17.410156 20.925781 17.285156 Z M 17.964844 19.917969 L 17.644531 19.730469 L 16.785156 19.21875 L 15.507812 18.460938 L 13.9375 17.527344 L 12.207031 16.5 C 10.566406 15.523438 8.925781 14.539062 7.292969 13.546875 C 6.917969 13.316406 6.542969 13.085938 6.167969 12.851562 C 5.949219 12.714844 5.726562 12.578125 5.515625 12.429688 C 5.492188 12.414062 5.464844 12.394531 5.441406 12.375 L 5.570312 12.472656 L 5.5625 12.464844 C 5.441406 12.355469 5.289062 12.292969 5.128906 12.285156 C 4.925781 12.285156 4.734375 12.390625 4.621094 12.5625 C 4.507812 12.730469 4.484375 12.949219 4.5625 13.140625 C 4.59375 13.214844 4.636719 13.28125 4.695312 13.339844 C 4.894531 13.492188 5.101562 13.632812 5.3125 13.765625 C 5.648438 13.976562 5.984375 14.183594 6.324219 14.390625 C 7.332031 15.007812 8.339844 15.617188 9.355469 16.226562 C 10.53125 16.929688 11.707031 17.632812 12.882812 18.332031 L 14.515625 19.300781 L 15.886719 20.113281 L 16.867188 20.695312 C 17.023438 20.785156 17.175781 20.878906 17.332031 20.96875 L 17.351562 20.980469 C 17.640625 21.152344 18.015625 21.050781 18.1875 20.757812 C 18.359375 20.464844 18.261719 20.085938 17.96875 19.914062 Z M 17.964844 19.917969 "/><path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,44.705883%,88.235295%);fill-opacity:1;" d="M 0.964844 15.71875 C 1.488281 16.105469 2.035156 16.457031 2.605469 16.777344 C 3.628906 17.402344 4.652344 18.019531 5.683594 18.632812 C 7.875 19.9375 10.070312 21.234375 12.269531 22.53125 C 12.730469 22.800781 13.1875 23.078125 13.648438 23.34375 C 13.96875 23.523438 14.296875 23.691406 14.625 23.863281 C 15.011719 24.089844 15.425781 24.277344 15.851562 24.421875 C 16.296875 24.542969 16.765625 24.5625 17.21875 24.480469 C 18.140625 24.261719 19 23.824219 19.722656 23.203125 C 20.707031 22.453125 21.621094 21.621094 22.5625 20.820312 C 24.171875 19.453125 25.9375 18.246094 27.421875 16.734375 C 28.015625 16.21875 28.457031 15.546875 28.703125 14.796875 C 28.808594 14.410156 28.75 13.996094 28.542969 13.652344 C 28.28125 13.289062 27.9375 12.992188 27.539062 12.785156 C 27.085938 12.539062 26.621094 12.320312 26.144531 12.125 C 25.570312 11.878906 25.027344 11.65625 24.414062 11.375 C 23.777344 11.085938 23.160156 10.753906 22.570312 10.378906 C 22.414062 10.277344 22.265625 10.175781 22.117188 10.070312 L 22.007812 9.984375 C 21.988281 9.972656 21.878906 9.894531 21.957031 9.949219 C 22.039062 10.003906 21.914062 9.914062 21.894531 9.898438 C 21.527344 9.609375 21.195312 9.277344 20.898438 8.914062 C 20.886719 8.898438 20.875 8.878906 20.863281 8.867188 C 20.820312 8.8125 20.898438 8.910156 20.898438 8.910156 C 20.84375 8.890625 20.753906 8.710938 20.722656 8.664062 C 20.597656 8.472656 20.484375 8.273438 20.386719 8.0625 L 20.359375 8.007812 C 20.328125 7.933594 20.339844 8.015625 20.375 8.042969 C 20.324219 8.003906 20.296875 7.828125 20.277344 7.773438 C 20.214844 7.585938 20.167969 7.394531 20.136719 7.199219 C 20.132812 7.179688 20.128906 7.15625 20.125 7.136719 C 20.109375 7.066406 20.132812 7.195312 20.132812 7.191406 C 20.121094 7.140625 20.117188 7.089844 20.117188 7.039062 C 20.09375 6.78125 20.097656 6.519531 20.121094 6.257812 C 20.121094 6.234375 20.125 6.210938 20.128906 6.1875 C 20.144531 6.03125 20.113281 6.273438 20.128906 6.183594 C 20.164062 5.953125 20.214844 5.726562 20.277344 5.5 C 20.328125 5.320312 20.386719 5.140625 20.457031 4.96875 L 20.5 4.855469 C 20.648438 4.507812 20.839844 4.171875 21.0625 3.863281 C 21.074219 3.84375 21.160156 3.726562 21.097656 3.816406 C 21.03125 3.902344 21.109375 3.796875 21.125 3.777344 C 21.257812 3.613281 21.402344 3.453125 21.554688 3.304688 C 21.675781 3.191406 21.796875 3.082031 21.917969 2.984375 C 21.9375 2.964844 22.046875 2.878906 21.96875 2.941406 C 22.054688 2.875 22.140625 2.8125 22.230469 2.753906 C 22.511719 2.5625 22.808594 2.394531 23.117188 2.25 L 23.238281 2.195312 C 23.320312 2.160156 23.308594 2.1875 23.230469 2.195312 C 23.324219 2.171875 23.414062 2.132812 23.5 2.089844 C 23.835938 1.964844 24.179688 1.867188 24.53125 1.792969 C 24.617188 1.773438 24.703125 1.757812 24.785156 1.742188 C 24.84375 1.730469 25.039062 1.734375 25.085938 1.695312 L 25.023438 1.703125 L 25.085938 1.695312 L 25.226562 1.679688 C 25.519531 1.652344 25.808594 1.636719 26.101562 1.636719 C 26.394531 1.636719 26.6875 1.652344 26.976562 1.683594 L 27.109375 1.699219 C 27.171875 1.707031 27.304688 1.707031 27.164062 1.703125 C 27.371094 1.722656 27.574219 1.757812 27.777344 1.8125 C 28.1875 1.898438 28.59375 2.011719 28.992188 2.148438 C 29.089844 2.183594 29.1875 2.21875 29.28125 2.253906 L 29.4375 2.320312 L 29.5 2.34375 C 29.609375 2.390625 29.4375 2.316406 29.507812 2.347656 C 29.925781 2.53125 30.328125 2.738281 30.71875 2.96875 C 31.023438 3.148438 31.316406 3.34375 31.605469 3.550781 L 31.730469 3.644531 L 31.816406 3.710938 C 31.890625 3.765625 31.746094 3.652344 31.820312 3.710938 C 32.664062 4.402344 33.433594 5.183594 34.113281 6.042969 C 34.402344 6.394531 34.6875 6.753906 34.96875 7.117188 L 35.027344 7.191406 C 35.019531 7.179688 34.980469 7.132812 35.027344 7.191406 L 35.175781 7.386719 C 35.484375 7.796875 35.785156 8.21875 36.078125 8.640625 C 36.546875 9.320312 36.96875 10.035156 37.332031 10.773438 L 37.535156 11.226562 C 37.535156 11.226562 37.480469 11.09375 37.515625 11.175781 L 37.535156 11.226562 C 37.546875 11.261719 37.5625 11.300781 37.578125 11.339844 C 37.710938 11.675781 37.816406 12.019531 37.894531 12.375 C 37.921875 12.5 37.945312 12.632812 37.964844 12.765625 C 37.972656 12.820312 37.972656 12.933594 37.960938 12.726562 C 37.960938 12.753906 37.96875 12.78125 37.96875 12.808594 C 38.019531 13.230469 38.019531 13.65625 37.96875 14.082031 C 37.96875 14.109375 37.964844 14.140625 37.960938 14.167969 C 37.957031 14.199219 37.941406 14.316406 37.960938 14.191406 C 37.980469 14.0625 37.960938 14.171875 37.960938 14.199219 C 37.960938 14.226562 37.949219 14.265625 37.945312 14.300781 C 37.90625 14.539062 37.859375 14.773438 37.800781 15.007812 C 37.742188 15.265625 37.675781 15.519531 37.605469 15.777344 C 37.566406 15.898438 37.523438 16.019531 37.476562 16.140625 C 37.441406 16.238281 37.527344 16.03125 37.46875 16.160156 C 37.390625 16.335938 37.300781 16.511719 37.207031 16.679688 C 37 17.039062 36.773438 17.386719 36.519531 17.714844 C 36.457031 17.800781 36.585938 17.636719 36.484375 17.757812 L 36.398438 17.871094 C 36.320312 17.964844 36.242188 18.058594 36.164062 18.152344 C 36.023438 18.320312 35.875 18.488281 35.726562 18.652344 C 35.109375 19.332031 34.445312 19.96875 33.765625 20.582031 C 33.1875 21.109375 32.589844 21.621094 31.996094 22.132812 C 31.777344 22.328125 31.554688 22.519531 31.34375 22.71875 C 31.25 22.804688 31.164062 22.894531 31.070312 22.980469 C 31.046875 23 30.910156 23.109375 30.988281 23.054688 C 30.941406 23.085938 30.894531 23.117188 30.847656 23.148438 C 30.800781 23.179688 30.738281 23.214844 30.683594 23.238281 L 30.613281 23.273438 C 30.730469 23.21875 30.621094 23.265625 30.59375 23.273438 C 30.496094 23.304688 30.394531 23.328125 30.292969 23.351562 C 30.257812 23.359375 30.179688 23.355469 30.320312 23.351562 C 30.300781 23.351562 30.277344 23.355469 30.257812 23.355469 C 30.214844 23.355469 30.171875 23.363281 30.128906 23.363281 C 30.03125 23.363281 29.933594 23.359375 29.839844 23.351562 C 29.78125 23.347656 29.914062 23.371094 29.851562 23.355469 C 29.8125 23.347656 29.769531 23.339844 29.730469 23.332031 C 29.609375 23.308594 29.492188 23.273438 29.375 23.234375 L 29.308594 23.210938 C 29.214844 23.175781 29.375 23.238281 29.398438 23.246094 L 29.359375 23.230469 C 29.171875 23.105469 28.925781 23.09375 28.726562 23.203125 C 28.527344 23.3125 28.402344 23.523438 28.40625 23.753906 C 28.410156 23.984375 28.539062 24.191406 28.742188 24.296875 C 29.371094 24.601562 30.082031 24.675781 30.761719 24.511719 C 31.496094 24.230469 32.148438 23.773438 32.667969 23.179688 C 33.933594 22.070312 35.222656 20.992188 36.375 19.761719 C 37.019531 19.097656 37.597656 18.367188 38.101562 17.582031 C 38.480469 16.960938 38.757812 16.285156 38.929688 15.574219 C 39.21875 14.539062 39.292969 13.453125 39.144531 12.390625 C 38.859375 11.015625 38.296875 9.714844 37.496094 8.570312 C 36.90625 7.648438 36.253906 6.777344 35.578125 5.921875 C 34.886719 4.992188 34.113281 4.128906 33.273438 3.335938 C 31.84375 2.027344 30.113281 1.101562 28.234375 0.652344 C 26.625 0.269531 24.945312 0.328125 23.371094 0.832031 C 21.949219 1.28125 20.71875 2.191406 19.871094 3.425781 C 19.378906 4.179688 19.0625 5.03125 18.9375 5.921875 C 18.796875 6.851562 18.929688 7.804688 19.320312 8.660156 C 20.058594 10.039062 21.207031 11.148438 22.609375 11.832031 C 23.464844 12.292969 24.347656 12.703125 25.25 13.070312 L 25.550781 13.195312 C 25.695312 13.257812 25.835938 13.320312 25.972656 13.378906 C 26.210938 13.484375 26.449219 13.59375 26.679688 13.714844 C 26.867188 13.808594 27.050781 13.917969 27.226562 14.035156 C 27.25 14.050781 27.359375 14.148438 27.296875 14.082031 C 27.234375 14.019531 27.332031 14.117188 27.355469 14.132812 C 27.375 14.152344 27.40625 14.183594 27.433594 14.210938 C 27.449219 14.226562 27.464844 14.246094 27.480469 14.261719 C 27.542969 14.320312 27.449219 14.234375 27.445312 14.214844 C 27.445312 14.234375 27.496094 14.285156 27.511719 14.304688 C 27.527344 14.328125 27.523438 14.332031 27.53125 14.347656 C 27.585938 14.421875 27.5 14.292969 27.507812 14.28125 C 27.511719 14.3125 27.523438 14.339844 27.535156 14.367188 C 27.566406 14.441406 27.519531 14.304688 27.527344 14.289062 L 27.53125 14.433594 C 27.53125 14.527344 27.480469 14.5 27.539062 14.390625 C 27.515625 14.453125 27.5 14.519531 27.492188 14.582031 C 27.480469 14.617188 27.464844 14.648438 27.457031 14.683594 C 27.449219 14.699219 27.519531 14.546875 27.460938 14.667969 C 27.363281 14.871094 27.238281 15.066406 27.097656 15.25 C 27.113281 15.25 27.179688 15.148438 27.121094 15.21875 C 26.511719 15.933594 25.835938 16.585938 25.101562 17.171875 C 24.253906 17.882812 23.375 18.558594 22.515625 19.257812 C 21.574219 20.023438 20.671875 20.839844 19.742188 21.617188 L 19.425781 21.871094 L 19.261719 22.003906 L 19.191406 22.058594 C 19.253906 22.007812 19.179688 22.070312 19.152344 22.089844 C 18.953125 22.242188 18.746094 22.390625 18.539062 22.53125 C 18.339844 22.667969 18.136719 22.792969 17.925781 22.90625 C 17.828125 22.960938 17.726562 23.011719 17.625 23.058594 C 17.570312 23.082031 17.503906 23.105469 17.601562 23.070312 C 17.546875 23.089844 17.492188 23.113281 17.433594 23.132812 C 17.339844 23.167969 17.242188 23.199219 17.140625 23.222656 C 17.101562 23.230469 16.878906 23.308594 16.855469 23.28125 C 16.855469 23.28125 17.011719 23.265625 16.894531 23.273438 L 16.828125 23.277344 C 16.78125 23.28125 16.734375 23.285156 16.6875 23.285156 C 16.65625 23.285156 16.398438 23.277344 16.402344 23.273438 C 16.402344 23.269531 16.558594 23.300781 16.441406 23.277344 L 16.378906 23.265625 C 16.230469 23.238281 16.089844 23.195312 15.953125 23.140625 C 15.9375 23.136719 15.867188 23.101562 15.9375 23.132812 L 15.757812 23.050781 C 15.128906 22.742188 14.515625 22.40625 13.910156 22.054688 C 12 20.929688 10.089844 19.800781 8.183594 18.667969 C 7.011719 17.976562 5.847656 17.28125 4.679688 16.582031 C 3.855469 16.082031 3.023438 15.585938 2.207031 15.070312 C 2.101562 15.007812 1.996094 14.9375 1.890625 14.867188 C 1.851562 14.84375 1.816406 14.816406 1.777344 14.792969 L 1.734375 14.761719 C 1.65625 14.707031 1.835938 14.839844 1.824219 14.832031 C 1.582031 14.597656 1.199219 14.597656 0.957031 14.832031 C 0.722656 15.074219 0.722656 15.460938 0.957031 15.703125 Z M 0.964844 15.71875 "/><path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,44.705883%,88.235295%);fill-opacity:1;" d="M 35.59375 11.648438 C 35.320312 11.179688 34.8125 10.90625 34.277344 10.933594 C 34.277344 10.933594 36.390625 10.652344 36.484375 12.027344 Z M 35.59375 11.648438 "/></g></svg>') !important;
			background-size: contain;
			background-repeat: no-repeat;
		}
	}
</style>
